import React from 'react';

import { Badge, cn } from '@column/ui';

import { type PlatformLevelType } from '~/models';

const PLATFORM_LEVEL_LABELS: Record<PlatformLevelType, string> = {
  basic: 'Basic',
  self_id: 'Self ID',
  sandbox_only: 'Sandbox Only',
  kyb_pending: 'KYB Pending',
  industry_verification_pending: 'Industry Verification Pending',
  commercial_customer: 'Commercial Customer',
  enhanced_diligence_required: 'Enhanced Diligence Required',
};

interface Props {
  level: PlatformLevelType;
  className?: string;
}

export const PlatformLevelChip: React.FC<Props> = ({ level, className }) => (
  <Badge
    variant="outline"
    data-cy="platform-level"
    className={cn(
      'rounded-lg border-gray-200 px-2.5 py-1 text-sm leading-5 font-medium text-gray-600 dark:border-white/10 dark:text-gray-100',
      className
    )}
  >
    {PLATFORM_LEVEL_LABELS[level] ?? level}
  </Badge>
);
